import { render, staticRenderFns } from "./TableCellTaskStatus.vue?vue&type=template&id=4f5cce19&scoped=true"
import script from "./TableCellTaskStatus.vue?vue&type=script&lang=ts"
export * from "./TableCellTaskStatus.vue?vue&type=script&lang=ts"
import style0 from "./TableCellTaskStatus.vue?vue&type=style&index=0&id=4f5cce19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cce19",
  null
  
)

export default component.exports